import React, { useState } from 'react';
import postIcon from './postIcon.png';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';





const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const ResponsiveTableContainer = ({ children }) => (
    <div style={{ overflowX: 'auto', width: '100%', marginTop: '8px', marginBottom: '16px' }}>
        {children}
    </div>
);

const Info6 = () => {
    const [openResponse, setOpenResponse] = useState(null);

    const toggleResponse = (code) => {
        setOpenResponse(openResponse === code ? null : code);
    };

    return (
        <div style={{
            fontFamily: 'Gilroy-Light',
            lineHeight: 1.6,
            overflowX: 'auto',
            width: '100%',
            maxWidth: '100vw', 
            boxSizing: 'border-box',
            padding: '0px 16px',
        }}>
            <h2 style={{ marginTop: 0 }}><strong>Client Credentials Flow</strong></h2>

            <p>
                Client Credentials Flow, part of the <a href="https://oauth.net/2/" target="_blank" rel="noreferrer">OAuth 2.0 protocol</a> (<a href="https://auth0.com/docs/authorization/flows/client-credentials-flow" target="_blank" rel="noreferrer">Client Credentials Flow - auth0.com</a>),
                enables secure authorization without the need for user authentication. In this flow, applications obtain an access token using their unique client ID and secret, allowing them to interact with APIs.
                It's commonly used for public API access, as the application operates independently of a specific user.
                While offering a straightforward and secure means of access, it is not suitable for scenarios requiring user-specific data access, where other flows like Authorization Code or Password Flow might be more appropriate.
            </p>

            <p>
                By using this method, you can obtain tokens for calling Albaraka Public APIs and Analytic APIs solely with your <code>client_id</code> and <code>client_secret</code> credentials.
            </p>

            <p>The required POST request address is as follows:</p>
            <ul>
                <li>
                    <img src={postIcon} alt="POST" style={{ width: '32px', verticalAlign: 'middle', marginRight: '8px' }} />
                    <strong>For test environment:</strong><br />
                    <code>https://apitest.albarakaturk.com.tr/ocf-auth-server/auth/oauth/token</code>
                </li>
                <li style={{ marginTop: '10px' }}>
                    <img src={postIcon} alt="POST" style={{ width: '32px', verticalAlign: 'middle', marginRight: '8px' }} />
                    <strong>For production environment:</strong><br />
                    <code>https://api.albarakaturk.com.tr/ocf-auth-server/auth/oauth/token</code>
                </li>
            </ul>

            <h3><strong>Request</strong></h3>
            <p>
                The authorization type should be selected as <strong>basic authentication</strong>. In the basic Auth, the <code>Authorization</code> header transmits a Base64-encoded string,
                representing your <code>client_id</code> and <code>client_secret</code> values, to the API.
            </p>
            <p>
                The <code>client_id</code> and <code>client_secret</code> values differ between the production and test environments.
            </p>
            <ul>
                <li>
                    <strong>For the test environment:</strong> You can sign up on our website via the <a href="https://developer.albarakaturk.com.tr/register" target="_blank" rel="noreferrer">Albaraka Api Market</a> tab, create an application, and use the <code>client_id</code> and <code>client_secret</code> values that are automatically generated within the application. You can read our article on signing up for the portal and creating a test application:{' '}
                    <a href="https://medium.com/albaraka-open-banking/registering-on-albaraka-api-market-and-creating-a-test-application-305a6a303cc1" target="_blank" rel="noreferrer">
                        Registering on Albaraka API Market and Creating a Test Application | by Albaraka Open Banking | Albaraka Open Banking | Medium
                    </a>
                </li>
                <li style={{ marginTop: '8px' }}>
                    <strong>For the production environment:</strong> Please use the <code>client_id</code> and <code>client_secret</code> values provided to you after the necessary configurations are completed.
                </li>
            </ul>
            <p>
                <strong>Important Reminder:</strong> The <code>client_id</code> and <code>client_secret</code> values used in the test environment are not applicable in the production environment.
            </p>

            <h4><strong>Request Body Parameters</strong></h4>
            <p>Content-Type: <code>x-www-form-urlencoded</code></p>

            <ResponsiveTableContainer>
                <Table sx={{ minWidth: 200 }}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Value</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Required</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <StyledTableRow>
                            <StyledTableCell>grant_type</StyledTableCell>
                            <StyledTableCell>grant_type	A parameter in the OAuth 2.0 protocol indicating the type of authorization requested by a client.
                                client_credentials	true
                            </StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>client_credentials</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>scope</StyledTableCell>
                            <StyledTableCell>The group that includes the APIs you want to authorize. Please verify which scopes were activated during the application creation process. Ensure that your selection is made from the activated scopes</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>public</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                </Table>
            </ResponsiveTableContainer>

            <h3><strong>Responses</strong></h3>
            {[200, 400, 401, 500].map((code) => {
                const isOpen = openResponse === code;
                let title = '', content = null;

                if (code === 200) {
                    title = '200 OK';
                    content = (
                        <>
                            <br /><h5><strong>Parameters:</strong></h5><br />
                            <ResponsiveTableContainer>
                                <Table sx={{ minWidth: 600 }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>Access_token</StyledTableCell>
                                            <StyledTableCell>An authorized token to call Albaraka public or analytic APIs</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Token_type</StyledTableCell>
                                            <StyledTableCell>Always "bearer"</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Expires_in</StyledTableCell>
                                            <StyledTableCell>Expiration time of Access_token (seconds)</StyledTableCell>
                                            <StyledTableCell>integer</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Scope</StyledTableCell>
                                            <StyledTableCell>Authorized scope of Access Token</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </ResponsiveTableContainer>
                            <h3>Sample:</h3>
                            <pre>{`{
  "access_token": "5fb32009-b636-4441-b8a5-dd4187b2d038",
  "token_type": "bearer",
  "expires_in": 599,
  "scope": "public"
}`}</pre>
                        </>
                    );
                } else if (code === 400) {
                    title = '400 Bad Request';
                    content = (
                        <>
                            <br /><h5><strong>Parameters:</strong></h5><br />
                            <ResponsiveTableContainer>
                                <Table sx={{ minWidth: 600 }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>Error</StyledTableCell>
                                            <StyledTableCell>Description of the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Error_description</StyledTableCell>
                                            <StyledTableCell>Detailed information about the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </ResponsiveTableContainer>
                            <h3>Samples:</h3>
                            <p>Entering the grant_type information is mandatory. If the grant type information is not provided, the error returned is:</p>
                            <pre>{`{
  "error": "invalid_request",
  "error_description": "Missing grant type"
}`}</pre>
                            <p>The 'scope' parameter should be included even if no value is provided. The error received when it is not included is:</p>
                            <pre>{`{
  "error": "unsupported_grant_type",
  "error_description": "Unsupported grant type: client_credentials"
}`}</pre>
                        </>
                    );
                } else if (code === 401) {
                    title = '401 Unauthorized';
                    content = (
                        <>
                            <br /><h5><strong>Parameters:</strong></h5><br />
                            <ResponsiveTableContainer>
                                <Table sx={{ minWidth: 600 }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>Error</StyledTableCell>
                                            <StyledTableCell>Description of the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Error_description</StyledTableCell>
                                            <StyledTableCell>Detailed information about the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </ResponsiveTableContainer>
                            <h3>Samples:</h3>
                            <p>The error received when the client ID, client secret, or access URL is missing or incorrectly added is:</p>

                            <pre>{`{
  "error": "unauthorized",
  "error_description": "Full authentication is required to access this resource"
}`}</pre>
                        </>

                    );
                } else if (code === 500) {
                    title = '500 Internal Server Error';
                    content = (
                        <>
                            <br /><h5><strong>Parameters:</strong></h5><br />
                            <ResponsiveTableContainer>
                                <Table sx={{ minWidth: 600 }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>Error</StyledTableCell>
                                            <StyledTableCell>Description of the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Error_description</StyledTableCell>
                                            <StyledTableCell>Detailed information about the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </ResponsiveTableContainer>
                            <h3>Samples:</h3>
                            <p>This status code indicates an unexpected error occurred on the server while processing the request. It's a generic error message that doesn't provide specific details about the issue.</p>
                            <pre>{`{
  "error": "server_error",
  "error_description": "Internal Server Error"
}`}</pre>
                        </>

                    );
                }

                return (
                    <div key={code} style={{ background: '#f9f9f9', padding: '10px', marginBottom: '10px' }}>
                        <div
                            onClick={() => toggleResponse(code)}
                            style={{ cursor: 'pointer', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between' }}
                        >
                            <span>{title}</span>
                            <span>{isOpen ? '▲' : '▼'}</span>
                        </div>
                        {isOpen && <div style={{ marginTop: '10px' }}>{content}</div>}
                    </div>
                );
            })}
        </div>
    );
};

export default Info6;